import { ChakraProvider as ChakraProviderBase } from '@chakra-ui/react/styled-system'

import { chakraSystem } from 'theme/system'

import type { JSX, ReactNode } from 'react'

interface ProviderProperties {
  children: ReactNode
}

const ChakraProvider = ChakraProviderBase as unknown as (properties: {
  children: ReactNode
  value: unknown
}) => JSX.Element

export const Provider = ({ children }: ProviderProperties) => {
  /* --- Section 6: Render --- */
  return <ChakraProvider value={chakraSystem}>{children}</ChakraProvider>
}
